module.exports = __webpack_public_path__ + "img/10_35.b1a6a033.png";